export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'FACTURA RECTIFICATIVA',
    rectifies_invoice: 'Rectifica la factura {invoiceNumber} del {invoiceDate}',
    substitution_invoice_title: 'FACTURA SUSTITUTIVA',
    substitutes_simplified_invoice: 'Sustituye a la factura simplificada con número y serie {invoiceNumber}.',
    simplified_invoice_issue_date: 'Fecha de expedición de la factura simplificada: {invoiceDate}.',
    rectificative_reason_default: 'Motivo: Factura rectificativa por diferencias.',
    draft_watermark: 'BORRADOR',

    // QR and verification
    qr_label: 'QR tributario:',
    qr_verifiable: 'Factura verificable en la sede electrónica de la AEAT',

    // Invoice numbers and dates
    invoice_number_label: 'Número {documentType}: ',
    external_invoice_number: 'Número factura externo: ',
    invoice_date_label: 'Fecha {documentType}: ',
    due_date: 'Fecha vencimiento: ',
    operation_date: 'Fecha operación: ',
    start_date: 'Fecha inicio: ',
    end_date: 'Fecha final: ',
    signing_date: 'Fecha firma: ',

    // Supplier section
    issuer: 'Emisor',
    self_billing_notice: 'Facturación por el destinatario',
    business_name: 'Razón social: ',
    fiscal_name: 'Nombre fiscal: ',
    fiscal_address: 'Domicilio fiscal: ',
    nif_cif: 'NIF/CIF: ',
    bank_account: 'Número de cuenta: ',
    trade_name: 'Nombre Comercial: ',
    email_label: 'Email: ',
    phone_label: 'Teléfono:',
    website_label: 'Web:',

    // Customer section
    receiver: 'Receptor',
    dire_label: 'DIRe:',
    accounting_office: 'Despacho contable:',
    management_body: 'Órgano de gestión:',
    processing_unit: 'Unidad tramitadora:',
    proposing_body: 'Órgano proponente:',

    // Details section
    details: 'Detalles',
    details_of_budget: 'del presupuesto',
    details_of_delivery_note: 'del albarán',
    details_of_proforma: 'de la proforma',
    details_of_ticket: 'del ticket',
    details_of_invoice: 'de la factura',

    // Table headers
    description: 'Descripción',
    total: 'Total',
    quantity: 'Cantidad',
    unit_price: 'Precio unitario',
    discount: 'Descuento',
    discount_percentage: 'Descuento %',
    withholding: 'Retención',
    total_without_tax: 'Total (sin {taxType})',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Presupuesto',
    delivery_note_label: 'Albarán',
    date_of_proforma: 'Fecha de la proforma: ',
    date_of_budget: 'Fecha del presupuesto: ',
    date_of_delivery_note: 'Fecha del albarán: ',
    file_reference: 'Expediente',
    file_date: 'Fecha del expediente: ',
    client_reference: 'Referencia Cliente',

    // Totals section
    total_without_discounts: 'Total sin descuentos',
    line_discount: 'Descuento por línea',
    global_discount: 'Descuento global',
    total_without_taxes: 'Total sin impuestos',
    total_withholding: 'Total Retención',
    equivalence_surcharge_short: 'RE',
    total_document: 'Total {documentType}',
    withholding_label: 'Retención: ',
    reimbursable_label: 'Suplido: ',
    total_to_pay: 'Total a pagar',

    // Document types for dynamic text
    invoice: 'Factura',
    budget: 'Presupuesto',
    delivery_note: 'Albarán',
    proforma: 'Proforma',
    ticket: 'Ticket',

    // Footer
    page_number: 'Página {currentPage} de {totalPages}',
    document_info: 'Núm. {documentType}: {invoiceNumber} ({invoiceDate})',

    // Tax exemption reasons (IVA)
    tax_reason_isp: 'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.',
    tax_reason_ns: 'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.',
    tax_reason_ex: 'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.',
    tax_reason_nsrl: 'Operación no sujeta a IVA por reglas de localización en virtud del art. 69 de la Ley 37/1992, del IVA.',
    tax_reason_intra_bie: 'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.',
    tax_reason_intra_ser: 'Operación no sujeta a IVA en virtud del art. 69 de la Ley 37/1992, del IVA. Inversión del sujeto pasivo conforme a la Directiva 2006/112/CE.',
    tax_reason_export: 'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.',
    // Tax exemption reasons (IGIC)
    tax_reason_igic_art50: 'Operación exenta de IGIC en virtud del Art. 50 de la Ley 4/2012.',
    tax_reason_igic_art11: 'Operación exenta de IGIC en virtud del Art. 11 de la Ley 20/1991.',
    tax_reason_igic_art12: 'Operación exenta de IGIC en virtud del Art. 12 de la Ley 20/1991.',
    tax_reason_igic_art13: 'Operación exenta de IGIC en virtud del Art. 13 de la Ley 20/1991.',
    tax_reason_igic_art25: 'Operación exenta de IGIC en virtud del Art. 25 de la Ley 19/1994.',
    tax_reason_igic_art47: 'Operación exenta de IGIC en virtud del Art. 47 de la Ley 19/1994.',
    tax_reason_igic_art110: 'Operación exenta de IGIC en virtud del Art. 110 de la Ley 4/2012.',
    tax_reason_igic_otros: 'Operación exenta de IGIC.',

    // Payment methods
    payment_means_01: 'Pago al contado',
    payment_means_02: 'Pago por recibo domiciliado',
    payment_means_03: 'Pago por recibo',
    payment_means_04: 'Pago por transferencia',
    payment_means_05: 'Pago por letra aceptada',
    payment_means_06: 'Pago por crédito documentario',
    payment_means_07: 'Pago por contrato de adjudicación',
    payment_means_08: 'Pago por letra de cambio',
    payment_means_09: 'Pago por pagaré a la orden',
    payment_means_10: 'Pago por pagaré no a la orden',
    payment_means_11: 'Pago por cheque',
    payment_means_12: 'Pago por reposición',
    payment_means_13: 'Pago por medios especiales',
    payment_means_14: 'Pago por compensación',
    payment_means_15: 'Pago por giro postal',
    payment_means_16: 'Pago por cheque conformado',
    payment_means_17: 'Pago por cheque bancario',
    payment_means_18: 'Pago contra reembolso',
    payment_means_19: 'Pago mediante tarjeta',
    payment_means_13_1: 'Pago por PayPal',
    payment_means_13_2: 'Pago por Confirming',
  }
}
